package feature.businessType.event


enum class BusinessTypeEvent(val value: String) {
    CREATE("CREATE_BUSINESS_TYPE"),
    RETRIEVE("RETRIEVE_BUSINESS_TYPE"),
    UPDATE("UPDATE_BUSINESS_TYPE"),
    DELETE("DELETE_BUSINESS_TYPE"),
}
